import { ACTIVATE_HOOK, DEACTIVATE_HOOK, REGISTER_HOOK, UPDATE_HOOK } from '../../mutation-types';
import * as actions from './actions';


const mutations = {
    [ACTIVATE_HOOK](state, { id }) {
        if (!state.activeIds.includes(id)) {
            state.activeIds.push(id);
        }
    },
    [DEACTIVATE_HOOK](state, { id }) {
        const activeIdIndex = state.activeIds.indexOf(id);

        if (activeIdIndex > -1) {
            state.activeIds.splice(activeIdIndex, 1);
        }
    },
    [UPDATE_HOOK](state, { offset, id, rotation, position }) {
        const hookIndex = state.hooks.findIndex(hook => hook.id === id);

        if (hookIndex > -1) {
            state.hooks.splice(hookIndex, 1, { offset, id, rotation, position });
        }
    },
    [REGISTER_HOOK](state, hook) {
        state.hooks.push(hook);
    },
};

const state = {
    hooks: [],
    activeIds: [],
};

const getters = {
    activeHook: s => s.hooks.find(h => h.id === s.activeIds[0]),
};

export default {
    namespaced: true,
    getters,
    mutations,
    actions,
    state,
};
